// Using an `any` type here because of how low-level this function is &
// its varied use across product apps
export const isRenderable = (children: any): boolean =>
  children != null && children !== false;
